/**
 * Shared input validation helpers — mobile numbers and GST GSTIN format.
 * Used across all forms sitewide.
 */

/** Strip non-digits, max 10 chars. Returns validated value for state. */
export const handleMobileInput = (raw) => raw.replace(/\D/g, '').slice(0, 10);

/**
 * Positional GSTIN validation (15 chars):
 *   0-1   : digits (state code)
 *   2-6   : letters A-Z (PAN first 5 letters)
 *   7-10  : digits (PAN 4 digits)
 *   11    : letter A-Z (PAN last letter)
 *   12    : alphanumeric (entity number)
 *   13    : fixed 'Z'
 *   14    : alphanumeric (checksum)
 */
export const handleGSTInput = (raw) => {
  const upper = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
  let result = '';
  for (let i = 0; i < Math.min(upper.length, 15); i++) {
    const ch = upper[i];
    if (i < 2 && /[0-9]/.test(ch)) result += ch;
    else if (i >= 2 && i < 7 && /[A-Z]/.test(ch)) result += ch;
    else if (i >= 7 && i < 11 && /[0-9]/.test(ch)) result += ch;
    else if (i === 11 && /[A-Z]/.test(ch)) result += ch;
    else if (i === 12 && /[A-Z0-9]/.test(ch)) result += ch;
    else if (i === 13 && ch === 'Z') result += ch;
    else if (i === 14 && /[A-Z0-9]/.test(ch)) result += ch;
  }
  return result;
};

/** Returns an error string if invalid, or '' if valid / empty. */
export const validateMobile = (v) => {
  if (!v) return '';
  return /^\d{10}$/.test(v) ? '' : 'Mobile number must be exactly 10 digits';
};

export const validateGST = (v) => {
  if (!v) return '';
  return /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z0-9]Z[A-Z0-9]$/.test(v.toUpperCase())
    ? ''
    : 'Enter a valid 15-character GSTIN (e.g. 22ABCDE1234F1Z5)';
};
